import {YellowButtonExportLink, YellowButtonExportType} from '../models'
import {assertString, assertEnum} from '../utils'
import {AssertTypeFn} from './general'

export const yellowButtonExportLinkNormaliser: AssertTypeFn<
  YellowButtonExportLink
> = (obj) => ({
  link: assertString(obj.link),
  expiration: assertString(obj.expiration),
  exportType: assertEnum(obj.exportType, YellowButtonExportType),
})
